import React, { Component } from "react";
import { Box, Grid, Typography } from "@mui/material";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import CtBtn from "./CustomTool/CtBtn";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import CtDtp from "./CustomTool/CtDtp";
import CtTxt from "./CustomTool/CtTxt";
import CtART from "./CustomTool/ResponsiveTable";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";

import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { withRouter } from "../HOC/withRouter";
import "./AMCList.css";
import { connect } from "react-redux";

class ImportAMC extends Component {
  state = {
    formData: {
      importFileName: "",
    },
    dataLoadStatus: true,
    ARD: null,
    rowsCount: 0,
    rowsPerPage: 50,
  };

  //#region Component
  componentDidMount() {
    document.title = "Top India Elevator : AMC Entry";
  }
  //#endregion Component

  //#region handle
  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };
  //#endregion handle

  //region function

  //#endregion handle

  render() {
    return (
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        className="amc-import-popup"
      >
        <Typography className="amc-import-title">Import AMC</Typography>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="amc-import-form"
        >
          <Grid item>
            <CtTxt
              label="Import AMC"
              value={this.state.formData.importFileName}
              handleOnChange={this.handleOnChange}
              fullWidth
            />
          </Grid>
          <Grid item>
            <button type="button" className="amc-import-file-btn">
              Choose Excel File
            </button>
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="amc-import-btn-wrap"
        >
          <Grid item>
            <CtBtn
              label="Import"
              iconName="import-file"
              firstletterBig={false}
              className="secondary-button"
              width={120}
            />
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(ImportAMC))));
